import { PaymentVerifyPage } from "./payment-verify.component";
import { connect } from "react-redux";
import { confirmOrder } from "./../../api/order/orderAction";

const mapDispatchToProps = {
  confirmOrder,
};

const mapStateToProps = (state) => ({
  isLoading: state.orderPage.isLoading,
  isConfirmed: state.orderPage.isConfirmed,
  confirmedOrder: state.orderPage.confirmedOrder,
});

export const PaymentVerifyContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentVerifyPage);
